// Do not import with ".." only, as it leads to cyclic dependencies!
import React from 'react';
import { ErrorNotification } from '../notifications/error/ErrorNotification';
import { getDisplayName } from '@cp-shared-15/frontend-ui';

export type withNoConnectionHandlerProps = {
    hasError: boolean;
};

export const withNoConnectionHandler = <TProps extends Record<string, unknown>>(
    WrappedComponent: React.ComponentType<TProps>,
): React.FC<TProps & withNoConnectionHandlerProps> => {
    const Wrapper: React.FC<TProps & withNoConnectionHandlerProps> = ({
        hasError,
        ...props
    }: withNoConnectionHandlerProps) =>
        hasError ? <ErrorNotification testId={'no-connection-error'} /> : <WrappedComponent {...(props as TProps)} />;

    Wrapper.displayName = `withNoConnectionHandler(${getDisplayName(WrappedComponent)})`;

    return Wrapper;
};
